<div class="reports-container">
  @if (showIframe) {
    <iframe 
      #reportFrame
      src='/tools/reports/index.html'
      class="report-iframe">
    </iframe>
  }
</div>
